<template>
  <div class="estimate">
    <button class="btn btn-success mb-2" @click.prevent="print">PDFで保存</button>
    <div class="created-at">
      <dl>
        <dt>発行日:</dt>
        <dd>{{ new Date() | moment('YYYY年MM月DD日') }}</dd>
      </dl>
    </div>
    <div class="eligible-invoice-issuer">
      <dl>
        <dt>登録番号:</dt>
        <dd>T7010901027836</dd>
      </dl>
    </div>

    <h2>見積書</h2>

    <div class="header clearfix">
      <div class="left-box">
        <template v-if="order.group_name">
          <div class="group-name">{{order.group_name}}</div>

          <div class="customer-name">
            <dl>
              <dt>ご担当者名：</dt>
              <dd>{{order.customer_name}} 様</dd>
            </dl>
          </div>
        </template>
        <template v-else>
          <div class="group-name">{{order.customer_name}} 様</div>
        </template>

        <div class="delivery-on">
          <dl>
            <dt>配達日：</dt>
            <dd v-if="order.order_type === 'catering'">
              {{order.catering_on | moment("YYYY年MM月DD日")}}
            </dd>
            <dd v-else-if="order.order_type === 'delivery'">
              {{order.delivery_on | moment("YYYY年MM月DD日")}}
            </dd>
          </dl>
        </div>

        <div class="delivery-place">
          <dl>
            <dt>配達場所：</dt>
            <dd>{{order.prefecture}} {{order.city}} {{order.address}} {{order.building_name}}</dd>
          </dl>
        </div>

        <div class="price">
          <div>下記の通りお見積り申し上げます。</div>
          <div class="left">お見積り金額</div>
          <div class="right">
            {{calculationResult.total_price | currency}}
            <span>(税込)</span>
          </div>
        </div>
      </div><!-- /.left-box -->

      <div class="right-box">
        <img src="../../images/logo.png" class="mb-3" width="200">
        <div class="shop-tel">
          <dl>
            <dt>電話</dt>
            <dd>050-5434-9753</dd>
          </dl>
        </div>
        <div class="shop-address">
          <dl>
            <dt>住所</dt>
            <dd>
              〒112-0005
              <br>
              東京都文京区水道2-1-19 モンフェリーチェ1階
            </dd>
          </dl>
        </div>
        <div class="shop-email">
          <dl>
            <dt>Email</dt>
            <dd>info@catering-season.com</dd>
          </dl>
        </div>
      </div><!-- /.right-box -->
    </div><!-- /.clearfix -->

    <table class="price-table">
      <tbody><tr class="plan-tbl__row">
        <th>項目</th>
        <th v-if="order.order_type === 'delivery'">区分</th>
        <th>単価</th>
        <th>数量</th>
        <th>単位</th>
        <th>金額</th>
      </tr>

      <tr class="heading">
        <td :colspan="order.order_type == 'catering' ? 5 : 6">お料理</td>
      </tr>
      <tr class="plan-row">
        <td class="name">({{orderTypeJa[order.order_type]}}/{{mealTypeJa[order.meal_type]}}) {{order.plan_name}}</td>
        <td class="text-center" v-if="order.order_type === 'delivery'">※</td>
        <td class="unit-price">{{order.plan_price | currency({symbol: ''})}}</td>
        <td class="quantity">{{order.quantity}}</td>
        <td class="unit-name">人</td>
        <td class="price">{{order.quantity * order.plan_price | currency}}</td>
      </tr>
      <!-- 100名以上特典: お寿司を増量(無料) -->
      <tr class="sushi-more-row lo-benefit-row" v-if="largeOrder.sushi_more">
        <td class="name">100名以上特典：お寿司を増量（無料）</td>
        <td class="text-center" v-if="order.order_type === 'delivery'"></td>
        <td class="unit-price"></td>
        <td class="quantity"></td>
        <td class="unit-name"></td>
        <td class="price">{{0 | currency}}</td>
      </tr>

      <!-- ドリンクセット -->
      <template v-if="order.drink_sets.length > 0">
        <tr class="heading">
          <td :colspan="order.order_type === 'catering' ? 5 : 6">ドリンクセット</td>
        </tr>
        <tr class="drink-set-row" v-for="drink_set in order.drink_sets">
          <td class="name">{{drink_set.name}}</td>
          <td class="text-center" v-if="order.order_type === 'delivery'"></td>
          <td class="unit-price">{{drink_set.price | currency({symbol: ''})}}</td>
          <td class="quantity">{{drink_set.quantity}}</td>
          <td class="unit-name">セット</td>
          <td class="price">{{drink_set.quantity * drink_set.price | currency}}</td>
        </tr>
      </template>

      <!-- ドリンク(単品) -->
      <template v-if="singleDrinks.length > 0">
        <tr class="heading">
          <td :colspan="order.order_type === 'catering' ? 5 : 6">ドリンク(単品)</td>
        </tr>
        <tr class="drink-row" v-for="drink in singleDrinks">
          <td class="name">{{drink.name}}</td>
          <td class="text-center" v-if="order.order_type === 'delivery'">
            <span v-if="drink.kind == 'softdrink'">※</span>
          </td>
          <td class="unit-price">{{drink.price | currency({symbol: ''})}}</td>
          <td class="quantity">{{drink.quantity}}</td>
          <td class="unit-name">{{drink.unit_name}}</td>
          <td class="price">{{drink.quantity * drink.price | currency}}</td>
        </tr>
      </template>

      <!-- ドリンクプラン -->
      <template v-if="calculationResult.drink_plans.length > 0">
        <tr class="heading">
          <td :colspan="order.order_type === 'catering' ? 5 : 6">ドリンクプラン</td>
        </tr>
        <tr class="drink-plan-row" v-for="drink_plan in calculationResult.drink_plans">
          <td class="name">{{drink_plan.name}}</td>
          <td class="text-center" v-if="order.order_type === 'delivery'">※</td>
          <td class="unit-price">{{drink_plan.price | currency({symbol: ''})}}</td>
          <td class="quantity">{{drink_plan.quantity}}</td>
          <td class="unit-name">人</td>
          <td class="price">{{drink_plan.quantity * drink_plan.price | currency}}</td>
        </tr>
      </template>

      <!-- ドリンクオプション（追加料金あり。旧「ドリンクプラン変更」） -->
      <template v-if="paidDrinkPlanCustomizations.length > 0">
        <tr class="heading">
          <td :colspan="order.order_type === 'catering' ? 5 : 6">ドリンクオプション</td>
        </tr>
        <tr class="drink-plan-customization-row" v-for="customization in paidDrinkPlanCustomizations">
          <td class="name">{{customization.drink_plan_name}}（{{customization.description}}）</td>
          <td class="text-center" v-if="order.order_type === 'delivery'"></td>
          <td class="unit-price">{{customization.price | currency({symbol: ''})}}</td>
          <td class="quantity">{{customization.quantity}}</td>
          <td class="unit-name">人</td>
          <td class="price">{{customization.sub_total | currency}}</td>
        </tr>
      </template>

      <!-- 追加料理 -->
      <template v-if="calculationResult.dishes.length > 0">
        <tr class="heading">
          <td :colspan="order.order_type === 'catering' ? 5 : 6">追加料理</td>
        </tr>
        <tr class="dish-row" v-for="dish in calculationResult.dishes">
          <td class="name">{{dish.name}}</td>
          <td class="text-center" v-if="order.order_type === 'delivery'">※</td>
          <td class="unit-price">{{dish.price | currency({symbol: ''})}}</td>
          <td class="quantity">{{dish.quantity}}</td>
          <td class="unit-name">{{dish.unit_name}}</td>
          <td class="price">{{dish.quantity * dish.price | currency}}</td>
        </tr>
      </template>

      <!-- 料理内容変更（追加料金あり） -->
      <template v-if="paidCustomizations.length > 0">
        <tr class="heading">
          <td :colspan="order.order_type === 'catering' ? 5 : 6">料理内容変更</td>
        </tr>
        <tr class="customization-row" v-for="customization in paidCustomizations">
          <td class="name">{{customization.description}}</td>
          <td class="text-center" v-if="order.order_type === 'delivery'">※</td>
          <td class="unit-price">{{customization.price | currency({symbol: ''})}}</td>
          <td class="quantity">{{customization.quantity}}</td>
          <td class="unit-name">人</td>
          <td class="price">{{customization.sub_total | currency}}</td>
        </tr>
      </template>

      <!-- オプション -->
      <template v-if="order.use_tablecloth || order.use_exothermic_agent || order.use_plate">
        <tr class="heading">
          <td :colspan="order.order_type === 'catering' ? 5 : 6">オプション</td>
        </tr>

        <!-- 備品 -->
        <tr class="equipment-row" v-for="equipment in equipments">
          <td class="name">{{equipment.name}}</td>
          <td class="text-center" v-if="order.order_type === 'delivery'"></td>
          <td class="unit-price">{{equipment.price | currency({symbol: ''})}}</td>
          <td class="quantity">{{equipment.quantity}}</td>
          <td class="unit-name">{{equipment.unit_name}}</td>
          <td class="price">{{equipment.quantity * equipment.price | currency}}</td>
        </tr>

        <tr class="plate-row" :class="{ 'lo-benefit-row': largeOrder.plate_free }" v-if="order.use_plate">
          <td class="name" v-if="largeOrder.plate_free">100名以上特典：取皿セット<br>（通常 {{largeOrder.plate_regular_price | currency}}）</td>
          <td class="name" v-else>取皿セット</td>
          <td class="text-center" v-if="order.order_type === 'delivery'"></td>
          <td class="unit-price">{{calculationResult.plate.unit_price | currency({symbol: ''})}}</td>
          <td class="quantity">{{calculationResult.plate.quantity}}</td>
          <td class="unit-name">枚</td>
          <td class="price">{{calculationResult.plate.price | currency}}</td>
        </tr>

        <tr class="exothermic-row" v-if="order.use_exothermic_agent">
          <td class="name">発熱剤</td>
          <td class="text-center" v-if="order.order_type === 'delivery'"></td>
          <td class="unit-price">{{calculationResult.exothermic_agent.unit_price | currency({symbol: ''})}}</td>
          <td class="quantity">{{calculationResult.exothermic_agent.quantity}}</td>
          <td class="unit-name">個</td>
          <td class="price">{{calculationResult.exothermic_agent.price | currency}}</td>
        </tr>

        <tr class="tablecloth-row" :class="{ 'lo-benefit-row': largeOrder.tablecloth_free }" v-if="order.use_tablecloth">
          <td class="name" v-if="largeOrder.tablecloth_free">100名以上特典：テーブルクロス<br>（通常 {{largeOrder.tablecloth_regular_price | currency}}）</td>
          <td class="name" v-else>テーブルクロス</td>
          <td class="text-center" v-if="order.order_type === 'delivery'"></td>
          <td class="unit-price">{{calculationResult.tablecloth.unit_price | currency({symbol: ''})}}</td>
          <td class="quantity">{{calculationResult.tablecloth.quantity}}</td>
          <td class="unit-name">式</td>
          <td class="price">{{calculationResult.tablecloth.price | currency}}</td>
        </tr>
      </template>

      <template v-if="order.order_type === 'catering'">
        <tr class="heading">
          <td :colspan="order.order_type === 'catering' ? 5 : 6">その他</td>
        </tr>
        <tr class="worker-row" :class="{ 'lo-benefit-row': largeOrder.staff_free }">
          <td class="name" v-if="largeOrder.staff_free">100名以上特典：{{largeOrder.staff_label}}<br>（通常 {{largeOrder.staff_regular_price | currency}}）</td>
          <td class="name" v-else>
            スタッフ派遣料<br>
            <span v-if="calculationResult.drink_plans.length > 0">(バーテンダー料金)</span>
            <span v-else>(設置・撤収料金)</span>
          </td>
          <td class="unit-price">{{calculationResult.worker.unit_price | currency({symbol: ''})}}</td>
          <td class="quantity">{{calculationResult.worker.quantity}}</td>
          <td class="unit-name">人</td>
          <td class="price">{{calculationResult.worker.price | currency}}</td>
        </tr>
      </template>

      <!-- 100名以上特典: 早期ご予約割(注文日から催事日まで30日以上)。料理代から引いた額(ケータリング・オードブルとも) -->
      <template v-if="largeOrder.early_discount > 0">
        <tr class="heading">
          <td :colspan="order.order_type === 'catering' ? 5 : 6">割引</td>
        </tr>
        <tr class="early-discount-row lo-benefit-row">
          <td class="name">{{largeOrder.early_discount_label}}</td>
          <td class="text-center" v-if="order.order_type === 'delivery'">※</td>
          <td class="unit-price"></td>
          <td class="quantity"></td>
          <td class="unit-name"></td>
          <td class="price">−{{largeOrder.early_discount | currency}}</td>
        </tr>
      </template>

      <tr class="deliver-price">
        <td rowspan="4"></td>
        <td :colspan="order.order_type === 'catering' ? 3 : 4">
          <span v-if="calculationResult.delivery_price === 0 && calculationResult.delivery_regular_price > 0">送料（送料無料の条件を満たしています）</span>
          <span v-else-if="order.city">{{order.prefecture}}{{order.city}}への送料</span>
          <span v-else>送料(配達先住所が入力されていません)</span>
        </td>
        <td>
          {{calculationResult.delivery_price | currency}}
          <span v-if="calculationResult.delivery_price === 0 && calculationResult.delivery_regular_price > 0"><br>（通常 {{calculationResult.delivery_regular_price | currency}}）</span>
        </td>
      </tr>

      <tr class="sub-total">
        <td :colspan="order.order_type === 'catering' ? 3 : 4">小計金額</td>
        <td>{{calculationResult.normal_tax_rate.sub_total + calculationResult.reduced_tax_rate.sub_total | currency}}</td>
      </tr>

      <tr class="tax">
        <td :colspan="order.order_type === 'catering' ? 3 : 4">消費税</td>
        <td>{{calculationResult.normal_tax_rate.tax + calculationResult.reduced_tax_rate.tax | currency}}</td>
      </tr>

      <tr class="total-price">
        <td :colspan="order.order_type === 'catering' ? 3 : 4">合計金額</td>
        <td>{{calculationResult.total_price | currency}}</td>
      </tr>
      </tbody>
    </table>

    <div class="tab-table clearfix mb-2">
      <table class="tax-table">
        <tr class="reduced-tax-rate" v-if="order.order_type === 'delivery'">
          <td>8%対象</td>
          <td>{{calculationResult.reduced_tax_rate.sub_total | currency }}</td>
          <td>消費税</td>
          <td>{{calculationResult.reduced_tax_rate.tax | currency }}</td>
        </tr>
        <tr class="normal-tax-rate">
          <td>10%対象</td>
          <td>{{calculationResult.normal_tax_rate.sub_total | currency }}</td>
          <td>消費税</td>
          <td>{{calculationResult.normal_tax_rate.tax | currency }}</td>
        </tr>
      </table>
    </div>
    <p class="text-right mt-1" v-if="order.order_type === 'delivery'">※は軽減税率対象</p> 

    <div class="information">
      <div class="mb-3" v-if="order.order_type === 'catering'">
        <h3>ケータリング配達予定</h3>
        <p>
          配達予定日: {{order.catering_on | moment("YYYY年MM月DD日") || '配達日が決定していません。'}}<br>
          会場入り予定時間: {{order.catering_avalilable_time || '時間が決定していません。'}}<br>
          &#x203B; 搬入・準備に60分いただいております。
        </p>
      </div>

      <template v-else-if="order.order_type === 'delivery'">
        <div class="mb-3">
          <h3>オードブル配達予定</h3>
          <p>
            配達予定日: {{order.delivery_on | moment("YYYY年MM月DD日") || '配達日が決定していません。'}}<br>
            配達予定時間: {{order.delivery_time_range || '配達時間が決定していません。'}}<br>
            &#x203B; 道路状況により60分枠をとらさせていただいております。
          </p>
        </div>

        <div class="mb-3">
          <h3>消費税について</h3>
          <p>&#x203B; ドリンク(アルコール)、取皿セット、発熱剤、送料は消費税が10%のためお食事等の小計と消費税の表示を分けさせていただいております。</p>
        </div>
      </template>

      <div class="mb-3">
        <h3>キャンセル規定</h3>
        <ul>
          <li>ご注文後のキャンセルは以下のようになります。</li>
          <li>・納品日4日前（20:00以降）：50%</li>
          <li>・納品日3日前（20:00以降）：80%</li>
          <li>・納品日2日前（20:00以降）：100%</li>
          <li>※5万円以上のご注文の場合は、8日前（20:00以降）：30%かかります。</li>
          <li>※納品日が12月・3月・4月で20万円以上のご注文の場合は、8日前ではなく14日前（20:00以降）：30%かかります。</li>
          <li>※人数の減少の場合も、減少人数に対して上記%のキャンセル料がかかります。</li>
          <li>※キャンセル料のかかる期間に入ってからのご注文は、ご注文の時点から上記のキャンセル料がかかります。</li>
        </ul>
      </div>

      <div v-if="order.use_tablecloth">
        <h3>テーブルクロスについて</h3>
        <p>
          こちらが用意した料理とドリンクをご提供するテーブルのみにおつけします。<br>
          準備時間が短い場合やテーブルの形状によっては、テーブルクロスをおつけできない場合がございます。
        </p>
      </div>
    </div>
  </div>
</template>

<script>
  import { orderTypeJa, mealTypeJa }  from '../../utilities/locale';
  export default {
    props: {
      order: Object,
      calculationResult: Object,
      downloadEstimate: Function
    },
    data: function() {
      return {
        orderTypeJa,
        mealTypeJa
      }
    },
    methods: {
      print() {
        this.$emit('downloadEstimate')
      }
    },
    computed: {
      singleDrinks() {
        return this.order.drinks.filter(option => option.kind !== 'other');
      },
      equipments() {
        return this.order.drinks.filter(option => option.kind === 'other');
      },
      paidCustomizations() {
        return (this.calculationResult.customizations || []).filter(c => Number(c.price) > 0);
      },
      paidDrinkPlanCustomizations() {
        return (this.calculationResult.drink_plan_customizations || []).filter(c => Number(c.price) > 0);
      },
      // 100名以上の大口特典。古い計算結果(キー無し)でも表示が壊れないようにする
      largeOrder() {
        return this.calculationResult.large_order || {};
      },
    },
    beforeCreate: function () {
      if(window.innerWidth <= 736){
        document.querySelector("meta[name='viewport']").setAttribute("content", "width=736");
      }
    },
    destroyed: function () {
      document.querySelector("meta[name='viewport']").setAttribute("content", "width=device-width,initial-scale=1");
    }
  }
</script>

<style>
  /* 100名以上特典の行を目立たせる(簡易見積りと同じ色) */
  .estimate .lo-benefit-row td {
    background: #F8DECC;
    color: #A63508;
    font-weight: 700;
  }
</style>
